import { BlurhashCanvas } from 'react-blurhash';
import styled, { css } from 'styled-components';
import { device } from '../../../../ui-components/breakpoints';
import {
    fontWeightLight,
    playGrey10,
    playGrey15,
    regularBlack,
    regularWhite,
} from '../../../../ui-components/design-tokens';
import { Heading5, Heading5Typography } from '../../../../ui-components/typography/Heading.styles';
import { playFontSize } from '../../../../ui-components/typography/helpers';
import PlayText from '../../../../ui-components/typography/PlayText/PlayText';
import { VisuallyHidden } from '../../../../ui-components/utils.styles';
import PlayBadge from '../../../../ui-components/PlayBadge/PlayBadge';
import { ImageContainer } from 'app/ui-components/PlayImage/PlayImage.styles';

export const StyledTopArea = styled.div`
    overflow: hidden;
    @media ${device.GteMedium} {
        display: flex;
        flex: 1 auto;
        position: relative;
    }
`;

export const StyledTopAreaPlaceholder = styled(StyledTopArea)``;

export const StyledTopAreaLeft = styled.div`
    @media ${device.GteMedium} {
        width: calc(((100% / 5) * 3) - 4px);
    }

    @media ${device.FullScreen} {
        width: 50%;
    }

    ${ImageContainer} {
        background-color: rgba(0, 0, 0, 0.3);
    }
`;

export const StyledTopAreaLeftPlaceholder = styled(StyledTopAreaLeft)`
    padding-top: 56.25%;
    background-color: ${playGrey15};

    @media ${device.GteMedium} {
        padding-top: 33.547%;
    }

    @media ${device.FullScreen} {
        padding-top: 28.125%;
    }
`;

export const StyledTopAreaRight = styled.div`
    @media ${device.GteMedium} {
        position: relative;
        display: inline-flex;
        width: 40%;
    }
`;

export const StyledTopAreaRightPlaceholder = styled(StyledTopAreaRight)`
    background-color: ${playGrey10};
    align-self: stretch;
    height: 38px;
    margin-top: 15px;
    width: 50%;

    @media ${device.GteMedium} {
        margin-top: 0;
        height: auto;
    }
`;

export const StyledTopAreaMeta = styled.div`
    margin-top: 15px;

    @media ${device.GteMedium} {
        align-self: center;
        margin: 0 50px;
    }
`;

export const Byline = styled(PlayText)`
    text-transform: uppercase;
    letter-spacing: 0.4px;
`;

export const StyledTopAreaPlayButton = styled.a`
    ${playFontSize(1.3)}
    color: ${regularBlack};
    width: min-content;
    text-decoration: none;
    margin: 20px 0 15px;
    font-weight: 700;
    text-transform: uppercase;
    height: 37px;
    border: 1px solid transparent;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 33px;
    display: flex;
    justify-content: left;
    align-items: center;
    cursor: pointer;
    transition: max-width 500ms ease-in-out, background-color 120ms ease-in-out;
    position: relative;
    overflow: hidden;

    @media ${device.GteSmall} {
        margin: 20px 0 15px;
    }
    &:hover,
    &:focus {
        background-color: ${regularWhite};
    }

    &:focus {
        outline: none;
        border-color: ${regularBlack};
    }

    &:before {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        display: block;
        content: '';
        left: 10px;
        width: 23px;
        height: 23px;
        background: url("data:image/svg+xml;charset=utf-8,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 16 16' style='enable-background:new 0 0 16 16%3B' xml:space='preserve'%3E%3Cg id='svtplay_x5F_logo_3_' style='fill: %23000'%3E%3Cpolyline id='play_3_' points='4.243%2C2.685 4.243%2C13.315 11.757%2C8 4.243%2C2.685 '/%3E%3C/g%3E%3C/svg%3E")
            no-repeat;
    }

    @media ${device.GteMedium} {
        margin-top: 30px;
    }

    ${(props) =>
        props.onlyAvailableInSweden &&
        css`
            .no-sweden & {
                ${VisuallyHidden};
            }
        `}
`;

export const NotAvailableInSweden = styled(PlayText)`
    display: none;
    ${playFontSize(1.7)}
    margin-top: 10px;
    margin-bottom: 20px;

    @media ${device.GteSmall} {
        ${playFontSize(2)}
        margin-top: 30px;
        margin-bottom: 0;
    }

    ${(props) =>
        props.onlyAvailableInSweden &&
        css`
            .no-sweden & {
                display: block;
            }
        `}
`;

export const HiddenByline = styled.p`
    ${VisuallyHidden};
`;

export const StyledTopAreaPlayButtonText = styled.span`
    margin-left: 40px;
    margin-right: 30px;
    white-space: nowrap;
`;

export const StyledTopAreaTitle = styled(Heading5)`
    font-weight: ${fontWeightLight};
    display: inline-flex;
    align-items: center;
`;

export const StyledBlurHashCanvas = styled(BlurhashCanvas)`
    display: none;

    @media ${device.GteMedium} {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
        object-fit: cover;
        opacity: 0.4;
    }
`;

export const StyledTopAreaSubheading = styled.p`
    ${Heading5Typography};
    font-weight: normal;
    display: block;

    @media ${device.GteMedium} {
        margin-top: 4px;
    }
`;

export const StyledTopAreaBadge = styled(PlayBadge)`
    margin-bottom: 5px;

    @media ${device.GteLarge} {
        margin-bottom: 10px;
    }
`;
